function isOptionLike(val: object) {
    return 'value' in val && 'label' in val;
}

export function countDirtyFields(
    value: Record<any, any> | boolean,
    countObj?: { count: number }
): number {
    const _countObj = countObj ?? { count: 0 };
    if (typeof value === 'boolean') {
        if (value === true) _countObj.count++;
    } else {
        for (const key in value) {
            const val = value[key];
            if (typeof val === 'boolean') {
                if (val === true) {
                    _countObj.count++;
                }
            } else if (Array.isArray(val)) {
                val.forEach((_val) => {
                    if (typeof _val === 'object' && 'isRemoved' in _val && _val.isRemoved) {
                        _countObj.count++;
                    } else {
                        countDirtyFields(_val, _countObj);
                    }
                });
            } else if (typeof val === 'object' && val != null) {
                if (isOptionLike(val)) {
                    countDirtyFields({ value: val.value }, _countObj);
                } else {
                    countDirtyFields(val, _countObj);
                }
            }
        }
    }
    return _countObj.count;
}
